export function setupRoutes(routes) {
    const routeArr = routes.map(route => {
        const processedRoute = {
            path: route.path,
            meta: route.meta || {}
        };

        // 处理组件
        if (route.component) {
            if (route.component == 'Layout') {
                processedRoute.component = () => import(`@/views/layout/${route.component}.vue`);
            } else {
                processedRoute.component = () => import(`@/views/page/${route.component}.vue`);
            }
        }
        if (route.name) {
            processedRoute.name = route.name
        }

        if (route.is_props) {
            processedRoute.props = true
        }

        // 处理子路由
        if (route.children && route.children.length > 0) {
            processedRoute.children = processRoutes(route.children);
        }

        return processedRoute
    });

    const homeRouter = { path: '/home', name: '首页', component: () => import('@/views/page/Home.vue'), meta: {} }
    // const editPassRouter = { path: '/home', name: '首页', component: () => import('@/views/page/Home.vue'), meta: {} }
    routeArr.push(homeRouter)
    return routeArr;

    // console.log(this.$router.getRoutes())

    // const myRoutes = {
    //     path: '/home',
    //     component: () => import('@/views/layout/Layout.vue'),
    //     children: routeArr,
    // };
    // return myRoutes
}